import { environment } from '../../../environments/environment';

export const ThemeConfig = environment.themeConfig;
